export const GET_PAYMENT_METHODS = gql`
    query GetPaymentMethods {
        getPaymentMethods {
            displayed_as
            id
        }
    }
`;
